"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainDriverPolarAnswerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var MainDriverPolarAnswerWidget = /** @class */ (function (_super) {
    __extends(MainDriverPolarAnswerWidget, _super);
    function MainDriverPolarAnswerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        var driverIndex = (0, commonFunctions_1.getIndexSetting)("driverIndex", _this.getSetting("driverIndex", undefined), _this.props.question.type);
        _this.originalMainDriverId = _this.props.interaction.vehicles[_this.vehicleIndex].mainDriverId;
        if (driverIndex === 0 && !_this.props.interaction.temporaryDrivers || (_this.props.interaction.temporaryDrivers && _this.props.interaction.temporaryDrivers.length === 0)) {
            _this.driverId = _this.props.interaction.policyHolder.personId;
            _this.driver = _this.props.interaction.policyHolder;
        }
        else if (driverIndex === 0 && _this.props.interaction.temporaryDrivers && _this.props.interaction.temporaryDrivers.length !== 0) {
            _this.driverId = _this.props.interaction.temporaryDrivers[0].personId;
            _this.driver = _this.props.interaction.temporaryDrivers[0];
        }
        else {
            _this.driverId = _this.props.interaction.additionalDrivers[driverIndex - 1].personId;
            _this.driver = _this.props.interaction.additionalDrivers[driverIndex - 1];
        }
        _this.state = {
            driverIsTheMainDriver: _this.originalMainDriverId === _this.driverId
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    MainDriverPolarAnswerWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        var vehicle = interaction.vehicles[this.vehicleIndex];
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: this.props.question.name, children: "Is ".concat(this.driver.firstName, " ").concat(this.driver.lastName, " the main driver for ").concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")?") }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group", children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { id: "".concat(this.props.question.name, "-true"), className: "custom-control-input null", type: "radio", name: this.props.question.name, value: "true", checked: this.state.driverIsTheMainDriver, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-true"), children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { id: "".concat(this.props.question.name, "-false"), className: "custom-control-input null", type: "radio", name: this.props.question.name, value: "false", checked: !this.state.driverIsTheMainDriver, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-false"), children: "No" })] })] })] }));
    };
    MainDriverPolarAnswerWidget.prototype.handleOnChangeEvent = function (event) {
        var driverIsTheMainDriver = event.target.value === "true";
        if (driverIsTheMainDriver) {
            this.props.onStateChange(this.props.question.interactionField, this.driverId);
        }
        else {
            this.props.onStateChange(this.props.question.interactionField, this.originalMainDriverId);
        }
        this.setState({
            driverIsTheMainDriver: driverIsTheMainDriver
        });
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], MainDriverPolarAnswerWidget.prototype, "changelogRecorder", void 0);
    return MainDriverPolarAnswerWidget;
}(plugin_journey_1.WidgetBase));
exports.MainDriverPolarAnswerWidget = MainDriverPolarAnswerWidget;
//# sourceMappingURL=MainDriverPolarAnswerWidget.js.map